export default __webpack_public_path__ + "swim-safety-swim-icon.svg";